import {Howl, Howler} from 'howler';
import {gsap, Power1} from "gsap";

export default class AudioManager
{
    constructor( json)
    {
        
        this.audios = [];
        this.ids = [];
        this.events = [];
        this.vars = {"intro_complete" : false, "intro_start": false}
    
   
        for (let strKey in json)
        {
            let obj = json[strKey];
            let objAudio = {ready: false};
            
            console.log("%cAudio : " + strKey, "background-color:purple");
            console.log(obj);
            let strSrc = obj.sources.split("/").pop();
            let sprite = obj.sprite;
            objAudio.type = strKey;
            objAudio.audio = new Howl({
                                     src:     ["/_/audios/" + strSrc],
                                     preload: false,
                                     html5:   false,
                                     sprite
                                 });
    
            objAudio.audio.once ('load', () => this.onLoad(objAudio));
            objAudio.audio.on ('end', this.onSoundEnd.bind(this));
    
            objAudio.audio.load();
            
            
            this.audios.push (objAudio);
        }
        
        
        
        window.__AUDIO__ =  this;
    }
    
    checkEvents ()
    {
        requestAnimationFrame(() => this.checkEvents());
        
        if (this.events.length === 0)
            return;
    
        let time = new Date().getTime();
        
        let events = this.events.filter( e => e.at <= time);
        this.events = this.events.filter( e => e.at > time);
        
        for (let i = 0; i < events.length; i++)
        {
            let event = events[i];
            this.playSound(event.key);
        }
        
    }
    onLoad (objAudio)
    {
        objAudio.ready = true;
        
        this.checkEvents();
        console.log("%conLoad", "background-color:purple");
    }
    
    onSoundEnd (id)
    {
        
        let objAudio = this.ids.find ( obj => obj.id === id);
        this.ids = this.ids.filter ( obj  => obj.id !== id);
    
        
        if (objAudio)
        {
            console.log("%conSoundEnd " + id + " : " + objAudio.key, "background-color:#8FBC8F");
            if (objAudio.ended && objAudio.ended !== "")
            {
                this.playSound(objAudio.ended, objAudio.loop, objAudio.group, 0, 0, objAudio.volume);
            }
            else if (objAudio.loop)
            {
                this.playSound(objAudio.key, true, objAudio.group, 0, 0, objAudio.volume);
            }
        }
    }
    
    getAudio (strType)
    {
        return this.audios.find( o => o.type === strType)
    }
    
    muteSound (id = -1, key = "", group = "", fadeSpeed = 1000)
    {
        
        let sounds = this.ids.filter( sound => sound.group === group);
    
        let type = "SFX";
        let objAudio = this.getAudio(type);
        
        sounds.forEach( sound =>
                        {
                            objAudio.audio.fade(1, 0, fadeSpeed, sound.id);
                            sound.volume = 0;
                        })
        console.log("ids", this.ids);
        console.log("we should mute", sounds);
    }
    
    
    unmuteSound (id = -1, key = "", group = "", fadeSpeed = 1000)
    {
        let sounds = this.ids.filter( sound => sound.group === group);
        
        let type = "SFX";
        let objAudio = this.getAudio(type);
        
        sounds.forEach( sound =>
                        {
                            objAudio.audio.fade(0, 1, fadeSpeed, sound.id);
                            sound.volume = 1;
                        })
        console.log("we should mute", sounds);
    }
    
    playSound (strKey, loop = false, group = "", fadein = 0, fadeout = 100, volume = 1)
    {
 
        console.log("%cAudioManager.playSound : " + strKey + " Loop? " + loop + " Group : " + group, "background:purple; color: white; padding: 10px");
        
        if (!strKey || strKey === "")
            return;
        
        if (strKey === "INTRO")
        {
            if (this.vars["intro_start"])
                return;
            
            let type = "SFX";
            let objAudio = this.getAudio(type);
            let key = "VM_A_1_";
            let id = objAudio.audio.play(key + "020311");
            this.ids.push ({id, key, loop, type: "INTRO", volume: 1});
            
            let duration = objAudio.audio.duration(id) - 1;
            let time = new Date().getTime() + (duration * 1000);
            this.events.push ({key: "INTRO_LOOP_A_2", at: time});
            this.vars["intro_start"] = true;
            
            
        }
        else if (strKey === "INTRO_LOOP_A_2")
        {
            let type = "SFX";
            let objAudio = this.getAudio(type);
            let key = "VM_A_2_";
            let ended = "INTRO_LOOP_A_2";
            let id = objAudio.audio.play(key + "020311");
    
            let duration = objAudio.audio.duration(id) - 4;
            let time = new Date().getTime() + (duration * 1000);
            
            this.events.push({key: "INTRO_LOOP_A_2", at: time});
            
            
            this.ids.push ({id, key, loop, type: "INTRO", volume: 1});
        }
        else if (strKey === "INTRO_COMPLETE")
        {
             let type = "SFX";
             let objAudio = this.getAudio(type);
             let key = "VM_A_3_";
             let id = objAudio.audio.play(key + "020311");
             this.ids.push ({id, key, loop, type: "INTRO", volume: 1});
        
            this.stopSound(objAudio, "VM_A_2_", 3500,  "INTRO_LOOP_A_2");
        
        
        }
        else
        {
            let type = "SFX";
            let objAudio = this.getAudio(type);
            
            this.stopAllGroup(objAudio, group, fadeout);
            let id = objAudio.audio.play(strKey + "020311");
            
            if (volume < 1)
            {
                objAudio.audio.fade(1, 0, 0.001, id);
            }
    
            console.log("%cAudioManager.playSound id : " + id, "background:purple; color: white; padding: 10px");
    
            if (fadein > 0)
            {
                objAudio.audio.fade(0, 1, fadein, id);
            }
            
            
            let ended = "";
            
            if (loop)
            {
                ended = strKey;
            }
            this.ids.push ({id, key: strKey , loop, ended, group, volume});
        }
        
        
    }
    
    stopSound (objAudio,strKey, fadeout, strEventKey)
    {
        console.log("%stopSound :"  + strKey, "background-color:orange; padding: 10px;");
        
        if (objAudio === null)
        {
            objAudio = this.getAudio("SFX");
        }
        
        let arrFadeout = this.ids.filter( audio => audio.key === strKey);
        this.ids = this.ids.filter( audio => audio.key !== strKey);
        
        
        this.events = this.events.filter( event => event.key !== strEventKey);
    
        for (let i = 0; i < arrFadeout.length; i++)
        {
            let obj = arrFadeout[i];
        
            obj.loop = false;
            obj.group = "";
            obj.ended = "";
            
            if (fadeout > 0)
            {
                objAudio.audio.fade(1, 0, fadeout, obj.id);
            }
            else
            {
                objAudio.audio.stop( obj.id);
            }
        
            console.log("%cWe are stoping :" +  obj.key, "background-color:orange; padding: 10px;");
        }
    }
    
    stopAllGroup (objAudio, group, fadeout = 0)
    {
        
        if (objAudio === null)
        {
            objAudio = this.getAudio("SFX");
        }
        
        console.log("%cstopAllGroup :"  + group, "background-color:orange; padding: 10px;");
        let arrFadeout = this.ids.filter( audio => audio.group === group);
        this.ids = this.ids.filter( audio => audio.group !== group);
        
        for (let i = 0; i < arrFadeout.length; i++)
        {
            let obj = arrFadeout[i];
    
            obj.loop = false;
            obj.group = "";
            obj.ended = "";
            
            if (fadeout > 0)
            {
                objAudio.audio.fade(1, 0, fadeout, obj.id);
            }
            else
            {
                objAudio.audio.stop( obj.id);
            }
            
            console.log("%cWe should fade out :" +  obj.key, "background-color:orange; padding: 10px;");
        }
        
    }
    setVars (key, value)
    {
        this.vars[key] = value;
    }
    
    changeRate (strKey, start, end, duration)
    {
        let arrChangeRate = this.ids.filter( audio => audio.key === strKey);
        
        let objAudio = this.getAudio("SFX");
        
        for (let i = 0; i < arrChangeRate.length; i++)
        {
            let objRate = {val: start}
            let obj = arrChangeRate[i];
            gsap.to(objRate, {duration, val:end, ease:Power1.easeInOut,
                
                onUpdate:  () =>
                                                                {
                                                               
                                                                    objAudio.audio.rate(objRate.val, obj.id);
                                                                }})
        }
        
    }
    
}